module.exports = __webpack_public_path__ + "src/assets/textures/petri/alcohol_alco_lambert1_AO.jpg";